import * as React from 'react'

import {
  collapseBuildTypeBuildsSection,
  collapseSubproject,
  expandBuildTypeBuildsSection,
  expandSubproject,
} from '../../../actions'
import {useAppDispatch} from '../../../hooks/react-redux'
import type {BuildTypeId, ProjectId} from '../../../types'
import type {PostponedCallbackReturn} from '../../../utils/postponedTask'
import {useResetLoadingState} from '../SequenceLoader/SequenceLoader.hooks'

export function useProjectUnfolderCommonLogics() {
  const dispatch = useAppDispatch()

  const raf = React.useRef<PostponedCallbackReturn[]>([])
  const [processing, setProcessing] = React.useState(false)
  const resetLoadingState = useResetLoadingState()

  const expandEntities = React.useCallback(
    (buildTypeIds: BuildTypeId[], projectIds: ProjectId[]) => {
      if (buildTypeIds.length) {
        dispatch(expandBuildTypeBuildsSection(buildTypeIds))
      }

      if (projectIds.length) {
        dispatch(expandSubproject(projectIds))
      }
    },
    [dispatch],
  )

  const collapseEntities = React.useCallback(
    (buildTypeIds: BuildTypeId[], projectIds: ProjectId[]) => {
      if (buildTypeIds.length) {
        dispatch(collapseBuildTypeBuildsSection(buildTypeIds))
      }

      if (projectIds.length) {
        dispatch(collapseSubproject(projectIds))
      }
    },
    [dispatch],
  )

  return {
    raf,
    processing,
    setProcessing,
    resetLoadingState,
    expandEntities,
    collapseEntities,
  }
}
